"use client"; // Ensures this code runs on the client side

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation"; // Change this to next/navigation
import { analytics } from "@/lib/segment"; // Ensure this path is correct

export default function Analytics() {
  const [isAnalyticsReady, setIsAnalyticsReady] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (analytics && analytics.ready) {
      analytics.ready(() => {
        setIsAnalyticsReady(true);
      });
    } else {
      setIsAnalyticsReady(true);
    }
  }, []);

  useEffect(() => {
    if (isAnalyticsReady) {
      // Track the initial page view
      analytics.page();

      // Track route changes after the page is loaded
      const handleRouteChange = () => {
        analytics.page();
      };
    }
  }, [isAnalyticsReady, router.events]);

  return null;
}
